export enum SimCardOptions {
  RegisterNew = 'register_new',
  KeepExisting = 'keep_existing',
  SendToMail = 'send_to_mail',
  ESim = 'esim',
}
